import { MiniDonut } from "./MiniDonut";

export type BreakdownRow = { label: string; value: number };

export type BreakdownTileProps = {
  title: string;
  rows: [BreakdownRow, BreakdownRow];
  donutData: { value: number }[];
  // Fill for each donut slice, same order as `rows`/`donutData` — differs by card.
  donutColors: [string, string];
};

export const BreakdownTile = ({ title, rows, donutData, donutColors }: BreakdownTileProps) => (
  <div className="flex items-end gap-6 bg-white rounded-xl p-5 shrink-0">
    <div className="flex flex-col gap-1 text-sm whitespace-nowrap">
      <p className="font-medium text-primary">{title}</p>
      <div className="flex flex-col text-tertiary">
        {rows.map((row) => (
          <div key={row.label} className="flex items-center gap-1.5">
            <p>{row.label}</p>
            <p className="font-semibold">{row.value}</p>
          </div>
        ))}
      </div>
    </div>
    <MiniDonut data={donutData} colors={donutColors} size={60} />
  </div>
);
